import { DeleteEntityConfirmationModal } from '@/features/DirectoryGrid/components/DeleteEntityConfirmationModal';

interface DeleteVehicleConfirmationModalProps {
    isOpen: boolean;
    deleteInProgress?: boolean;
    count?: number;
    onConfirm: () => void;
    onCancel: () => void;
}

export function DeleteVehicleConfirmationModal(
    props: DeleteVehicleConfirmationModalProps,
) {
    return (
        <DeleteEntityConfirmationModal
            {...props}
            titleKey="vehicles.deleteVehicle"
            descriptionKey="vehicles.deleteConfirmation"
            submitKey="vehicles.card.delete"
            contentTestId="delete-vehicle-confirm-modal"
            submitButtonTestId="delete-vehicle-confirm-submit"
        />
    );
}
